import { InitializeApi } from "@ifgengineering/client-auth-sdk";
import { CUR8_API, CORE_API, APP_NAME } from "gatsby-env-variables";
import axios from "axios";

const isZakatApp = APP_NAME === "Zakat";

const authSdk = InitializeApi({
  serverURL: isZakatApp ? CUR8_API : CORE_API,
  appAxios: axios as any,
});

export default authSdk;
